import { grey } from '../colors';
export const defaultColor = (mode)=>{
    return mode === 'light' ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150]
    } : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800]
    };
};

//# sourceMappingURL=default.js.map